// @flow

import { getLabels } from 'forms/LicenseRequestForm/form/labels';
import moment from 'moment';
import type { TFunction } from 'react-i18next';

/**
 * Format the difference between two dates in "weeks and days". It will return an empty string
 * if any of the days are invalid.
 */
export const weeksAndDays = (
  startDate: moment$Moment | string | number | Date | number[],
  endDate: moment$Moment | string | number | Date | number[],
  t: TFunction
) => {
  const totalDays = Math.ceil(moment(endDate).diff(startDate, 'days', true));

  const fullWeeks = (!isNaN(totalDays) && Math.floor(totalDays / 7)) || 0;
  const fullDays = (!isNaN(totalDays) && totalDays - (fullWeeks || 0) * 7) || 0;

  const weeksPart = `${fullWeeks} ${t('general:labels.week', {
    count: fullWeeks,
  })}`;

  const daysPart = `${fullDays} ${t('general:labels.day', { count: fullDays })}`;

  const andConnector = `${t('general:labels.andConnector')}`;

  return `${weeksPart} ${andConnector} ${daysPart}`;
};
